import { useEffect, useRef } from 'react';
import { useAuth } from '@ochal/auth';

const sessionExpiryEvent = 'ochal:confirmed-session-expired';
export const sessionExpiredLoginUrl = '/login?reason=session-expired';

/** Called only by ApiClient after a final 401, never for timeout/network/5xx. */
export function notifySessionExpired(): void {
  window.dispatchEvent(new Event(sessionExpiryEvent));
}

export function SessionExpiryBridge({ redirect = (url: string) => window.location.replace(url) }: { redirect?(url: string): void }) {
  const { session, logout } = useAuth();
  const inFlight = useRef(false);
  useEffect(() => {
    const expire = () => {
      if (!session || inFlight.current) return;
      inFlight.current = true;
      // Standard logout clears local credentials and broadcasts to other tabs.
      void logout().catch(() => undefined).finally(() => redirect(sessionExpiredLoginUrl));
    };
    window.addEventListener(sessionExpiryEvent, expire);
    return () => window.removeEventListener(sessionExpiryEvent, expire);
  }, [logout, redirect, session]);
  return null;
}
